<template>
  <div class="view-content view11">
    <div class="left">
      <div class="title">{{ $t('官方路线图') }}</div>
    </div>
    <div class="right">
      <div class="tab">
        <div class="tab-item" v-for="(item, index) in tabList" :key="index" :class="{'active': item.id == currentTab}" @click="currentTab = item.id">
            {{ item.title }}
            <div class="div-no">
                <img src="./img/1030/view11-1.png" class="tab-item-acive" v-show="currentTab == item.id">
            </div>
        </div>
      </div>
      <div class="tab-content">
        <div class="tab-content-item" v-for="(item, index) in list" :key="index">
            <div class="tab-content-icon"></div>
            <div class="tab-content-content">
                <div class="tab-content-title">{{ item.title }}</div>
                <div class="tab-content-ul" v-for="(val, ind) in item.list" :key="ind">
                    <div class="tab-content-li">{{ val }}</div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'view11',
  data () {
    return {
        currentTab: "1",
        tabList: [
            {
                id: "1",
                title: this.$t('2025 — 创世与启动'),
            },
            {
                id: "2",
                title: this.$t('2025 — 增长与市场拓展'),
            },
            {
                id: "3",
                title: this.$t('2026 — 生态深化与 AI 赋能'),
            },
        ],
        list: [],
        list1: [
            {
                title: this.$t('上半年（Q2–Q3）'),
                list: [
                    this.$t('完成白皮书、制度模型与产品原型开发'),
                    this.$t('组织九大社区进行创世启动'),
                    this.$t('完成 300 个节点招募，发行 NECO & USAI 代币，添加初始流动性池'),
                    this.$t('发布 NECO APP BETA 测试版')
                ]
            },
            {
                title: this.$t('下半年（Q3–Q4）'),
                list: [
                    this.$t('全球社区运营中心部署完成'),
                    this.$t('NECO 优选店铺与创世商户上线'),
                    this.$t('推动注册用户突破 10 万'),
                    this.$t('启动空投及全球电商启动大会')
                ]
            }
        ],
        list2: [
            {
                title: this.$t('Q4：好货推广 & 本地电商'),
                list: [
                    this.$t('上线「好货系统」并开放会员商家入驻'),
                    this.$t('在主要国家开通 TePay 法币支付'),
                    this.$t('完成中国、韩国、越南 10 家 NECO Best 本地电商落地'),
                    this.$t('海外注册用户突破 50 万，VIP 用户突破 5 万'),
                    this.$t('举办第二次社区电商大会，开放跨境卖家注册'),
                    this.$t('拓展中东、南美、非洲与欧洲本地市场，整合供应链'),
                    this.$t('注册用户突破 100 万，VIP 用户突破 10 万')
                ]
            },
        ],
        list3: [
            {
                title: this.$t('Q1–Q2：体系完善'),
                list: [
                    this.$t('跨境卖家突破 10 万，商家数量超 10 万'),
                    this.$t('举办第一届 NECO 电商生态大会'),
                    this.$t('上线稳定币生态与信用体系'),
                    this.$t('注册用户突破 500 万，VIP 超过 20 万')
                ]
            },
            {
                title: this.$t('Q3–Q4：智能升级'),
                list: [
                    this.$t('获得主要国家支付牌照，全面上线法币支付服务'),
                    this.$t('上线 AI 选品与推荐功能'),
                    this.$t('商家信用、积分全面上链'),
                    this.$t('NECO Best 优选商家突破 100 家'),
                    this.$t('注册用户突破 1000 万，VIP 超过 50 万')
                ]
            }
        ],
    }
  },
  watch: {
    currentTab: {
        handler (newVal, oldVal) {
            if (newVal == "1") {
                this.list = this.list1
            } else if (newVal == "2") {
                this.list = this.list2
            } else if (newVal == "3") {
                this.list = this.list3
            }
        }
    }
  },
  created () {
    this.list = this.list1
  },
}
</script>

<style scoped>
@import "./css/index.css";

.view11 {
    flex-direction: column;
    justify-content: center;
}

.view11 .label {
    padding-top: 0;
}

.view11 .label {
    padding-right: 200px;
    color: #fff;
}

.view11 .left {
    flex: none;
    width: 100%;

}

.view11 .right {
    width: 100%;
    padding-top: 60px;
}

.tab-content-investor {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    padding-top: 40px;
}

.tab-content-operator {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: 20px;
    flex-shrink: 0;
}

.tab {
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 24px;
    font-weight: 700;
    gap: 20px;
    padding-bottom: 73px;
    align-self: stretch;
}

.tab-item {
    border: 1px solid #07C160;
    padding: 10px 24px;
    gap: 10px;
    cursor: pointer;
    flex: 1;
    position: relative;
    box-sizing: border-box;
    text-align: center;
    align-self: stretch;
    display: flex;
    align-items: center;
    justify-content: center;
}

.tab-item-acive {
    width: 29px;
    height: 29px;
    position: absolute;
    bottom: -60px;
    left: 50%;
    transform: translateX(-50%);
}

.active {
    background: #07C160;
}

.tab-content {
    width: 100%;
    display: flex;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.00) 100%);
    padding: 30px 30px 80px;
    box-sizing: border-box;
}

.tab-content-item {
    flex: 1;
    display: flex;
}

.tab-content-icon {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #07C160;
    margin-top: 6px;
}

.tab-content-content {
    flex: 1;
    padding-left: 7px;
}

.tab-content-title {
    color: #07C160;
    font-size: 16px;
    font-weight: 700;
}

.tab-content-ul {
    padding-top: 22px;
}

.tab-content-li {
    padding-bottom: 30px;
}

@media screen and (max-width: 768px) {
    .div-no {
        display: none;
    }
    .view11 {

    }
    .view11 .right {
        padding-top: 0;
    }
    .tab {
        display: block;
        padding-bottom: .1rem;
    }
    .tab-item {
        font-size: 16px;
        font-weight: 400;
        margin-bottom: .2rem;
        color: #808683;
    }
    .active {
        color: #fff;
        font-weight: 600;
    }
    .tab-content {
        padding: .2rem .16rem;
        flex-direction: column;
        box-sizing: border-box;
    }
    .tab-content-item {
        padding-bottom: 0.4rem;
        flex: none;
    }
    .tab-content-ul {
        padding-top: 0.1rem;
    }
    .tab-content-li {
        font-size: 14px;
        font-weight: 400;
        padding-bottom: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/lobby/components1030/view11.vue